import React from "react";
import "./App.css";
import Main from "./components/Main";

import SearchbarMenu from "./components/SearchbarMenu";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
